'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const CellExpandedContent = styled__default.default.div `
  font-size: ${({ theme }) => theme.typography.fontSize.xs};
  font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
  line-height: 1rem;
  letter-spacing: ${({ theme }) => theme.typography.letterSpacing.m};
  color: ${({ theme }) => theme.colors.body.text};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-height: 50vh;
`;
const CellExpandedContentPadding = styled__default.default.div `
  padding: ${({ theme }) => theme.designTokens.tableCellPadding};
  padding-top: 0;
  padding-left: ${({ theme }) => theme.designTokens.tableFirstColumCellPaddingLeft};
`;
const TableRowStyled = styled__default.default.tr `
  ${({ $collapsable }) => !$collapsable && 'height: 56px;'}

  ${({ $mode, theme, $isAlt }) => {
    switch ($mode) {
        case 'validated':
            return `background-color: ${theme.colors.success.alpha};`;
        case 'added':
        case 'modified':
            return `background-color: ${theme.palette.yellow400alpha};`;
    }
    if ($isAlt)
        return `background-color: ${theme.designTokens.tableAlternateRowBackgroundColor};`;
}}

  a {
    color: ${({ theme }) => theme.colors.body.text};
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
  ${({ $isClickable }) => $isClickable &&
    `
      &:hover {
        cursor: pointer;
      }
    `}

  ${({ $noHover, theme }) => !$noHover &&
    `
      &:hover {
        background-color: ${theme.colors.hover};
        a {
          color: ${theme.designTokens.anchorTextColor};
        }
      }
    `}

  ${({ $isSelected, theme }) => $isSelected &&
    `
      background-color: ${theme.palette.blue25};
      &:hover {
        background-color: ${theme.palette.blue50};
      }
    `}

  &[aria-expanded='false'] + tr ${CellExpandedContent} {
    max-height: 0;
  }

  ${({ $isEdit, theme }) => $isEdit &&
    `
      position: relative;
      pointer-events: none;

      td:first-child:after {
        content: '';
        background-color: ${theme.palette.grey300alpha};
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: ${theme.zIndices.tableFilter};
      }
    `}
`;

exports.CellExpandedContent = CellExpandedContent;
exports.CellExpandedContentPadding = CellExpandedContentPadding;
exports.TableRowStyled = TableRowStyled;
//# sourceMappingURL=row.styles.js.map
